import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body text-grey-900 m-0" }


  // Icons
  import ArrowRightIcon from '@/assets/ArrowRightIcon.vue'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionItem',
  props: {
    text: {
      type: String,
      required: true,
    },
    displayIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {

  // Vue
  

  // Emit
  const emit = __emit

  // Methods
  const handleClick = (): void => {
    emit('click')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex justify-content-between align-items-center border-bottom cursor-pointer py-3 px-2",
    onClick: handleClick
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.text), 1),
    (__props.displayIcon)
      ? (_openBlock(), _createBlock(ArrowRightIcon, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})